import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { HOME } from "../../AddonDiscovery/config/discoverCollections";
import { BAMBOO, BITBUCKET, CONFLUENCE, CROWD, FECRU, HIPCHAT, JIRA, JIRA_SERVICE_DESK, TRELLO } from "../constants/products";
const featuredAddonsHome = {
  title: 'Staff Picks',
  tagline: 'Try out any of these apps curated by our ecosystem team for free. We think they are a great place ' + "to start if you've never tried Atlassian Marketplace apps before.",
  curatedApps: undefined
};
const featuredAddonsJira = {
  title: 'Staff Picks',
  tagline: 'Try out any of these apps curated by our ecosystem team for free. We think they are a great place ' + "to start if you've never tried apps before with Jira.",
  curatedApps: undefined
};
const featuredAddonsJsd = {
  title: 'Staff Picks',
  tagline: 'Your favorite apps for ITSM, customer support and more - right at your fingertips.',
  curatedApps: undefined
};
const featuredAddonsConfluence = {
  title: 'Staff Picks',
  tagline: 'Top apps to transform and improve the way your teams work together, curated by Atlassian to ensure a seamless experience.',
  curatedApps: undefined
};
const featuredAddonsBitbucket = {
  title: 'Staff Picks',
  tagline: "Bitbucket is the Git solution for teams that's flexible, secure, and scalable. " + 'Streamline the development process through integrations and apps to give teams get a ' + 'tool that fits into the fabric of your organization.',
  curatedApps: undefined
};
export class FeaturedAddonsConfig extends Immutable.Record({
  /**
   * Value is an Immutable.List<String>
   */
  [HOME]: featuredAddonsHome,
  [JIRA]: featuredAddonsJira,
  [JIRA_SERVICE_DESK]: featuredAddonsJsd,
  [CONFLUENCE]: featuredAddonsConfluence,
  [BITBUCKET]: featuredAddonsBitbucket,
  [TRELLO]: undefined,
  [HIPCHAT]: undefined,
  [FECRU]: undefined,
  [BAMBOO]: undefined,
  [CROWD]: undefined
}) {
  static default_() {
    return new FeaturedAddonsConfig();
  }

}
export const FeaturedAddonsConfigPropType = PropTypes.instanceOf(FeaturedAddonsConfig);